import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IPartTypeApi } from "./base";
import { KeyValueDefault } from "../models/common";
import { GetQuotePartTypesByDirectAssignCriteriaResponse } from "@/main/models/response";

const baseRoute: string = "PartType";

export class PartTypeApi extends IPartTypeApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
		return api.get(`${baseRoute}/domain`);
	}

	GetPartTypesBySupplierAndQuoteItem(
		guidSupplier: string,
		guidQuoteItem: string,
	): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
		return api.get(`${baseRoute}/getparttypesbysupplierandquoteitem`, {
			params: { guidSupplier, guidQuoteItem },
		});
	}

	getPartTypeByDirectAssignCriteria(
		guidClaim?: string,
		guidQuote?: string,
		guidQuoteProcurement?: string,
	): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
		return api.post(`${baseRoute}/getparttypesbydirectassigncriteria`, {
			guidClaim,
			guidQuote,
			guidQuoteProcurement,
		});
	}

	getPartTypeByDirectAssignCriteriaCancelledParts(
		quoteGuids: string[],
	): Promise<AxiosResponse<Result<GetQuotePartTypesByDirectAssignCriteriaResponse[]>>> {
		return api.post(`${baseRoute}/getquoteparttypesbydirectassigncriteria`, {
			quoteGuids,
		});
	}
}
